import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect } from "react";

// Gets initial guest count from URL and sets it in the store
// covers edge cases like dates in the past or end date before start date
export const useGuestCountURLParams = () => {
  const setAdults = useEngineStore((state) => state.setDefaultAdults);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const guestCountParam = urlParams.get(URLParam.GuestCount);

    // Set default only if param is not present
    let guestCount = guestCountParam ? Number(guestCountParam) : 2;

    if (guestCount > 10) guestCount = 10;
    if (guestCount <= 0) guestCount = 2;

    setAdults(guestCount);
    // eslint-disable-next-line
  }, []);
};
